module.exports = __webpack_public_path__ + "assets/tagline_web_mobile_en.svg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/taglines/tagline_web_mobile_en.svg
// module id = 441
// module chunks = 19